import Vue from 'vue'
import Vuex from 'vuex';
import App from './App.vue'
import {store, i18n} from '@/src/main'

require('@/src/main')

/////////////
// Routers //
/////////////
import Router from 'vue-router'
Vue.use(Router)
import routes from './routes'
import middlewarePipeline from './routes/_middleware/middlewarePipeline'

const router=new Router({routes: routes})

router.beforeEach((to, from, next) => {
	if (!to.meta.middleware) {
    return next()
  }

  Vue.http.headers.common['Authorization']='Bearer '+store.getters['auth/access_token']
  const middleware = to.meta.middleware
  const context = {
    to,
    from,
    next,
    store
  }

  return middleware[0]({
		...context,
		next: middlewarePipeline(context, middleware, 1)
  })
	
})

Vue.http.options.root = '/api'
Vue.http.interceptors.push((request, next) => {

	return (response) => {
		if(response.status===401) {
			store.commit('auth/clear')
			Vue.swal({
				icon: 'error',
				title: 'Session Expired!',
				text: 'Please login again.',
				onClose(){
					router.replace('/')
				}
			})
		}
	}
})
/////////////
// Routers //
/////////////

new Vue({
  render: h => h(App),
  router: router,
  store,
  i18n
}).$mount('#app')